import { authLayout } from "../helpers/withAuth";

export const ipManagementRoutes = {
  path: "ipmanagement",
  ...authLayout("IP Management", [
    {
      path: "/ipmanagement/",
      lazy: () =>
        import("../../modules/ip_management").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/ipmanagement/pantheon",
      lazy: () =>
        import("../../modules/ip_management/pantheonList").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const dataMappingRoutes = {
  path: "datamapping",
  ...authLayout("Data Mapping", [
    {
      path: "/datamapping/idmanagement",
      lazy: () =>
        import("../../modules/data-mapping/id-mapping").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/datamapping/discover",
      lazy: () =>
        import("../../modules/discovery/discovery").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
